import React from 'react';
import { compose } from 'redux';
import DashboardTemplate from 'components/templates/Dashboard';
import HeaderContainer from 'containers/HeaderContainer';
import PageQuery from 'hoc/PageQuery';
import PageView from 'hoc/PageView';
import PageTitle from 'hoc/PageTitle';
import ProtectedRoute from 'hoc/ProtectedRoute';
import PageTheme from 'hoc/PageTheme';
import { pick } from 'lodash';

import DetermineLayerContainer from 'containers/dashboards/DetermineLayerContainer';
import LabsRealValueContainer from 'containers/labs/LabsRealValueContainer';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { SideBarObjects } from 'components/pages/config/DashboardSideBarObjects';
import showGGBrandingTheme from 'helpers/showGGBrandingTheme';
import { DASHBOARD_LABS_RV_VIEW, DASHBOARD_ACCESS } from 'constants/capabilities';
import { timeRanges } from 'services/config/duck';
import { getQueryParamDefForRange } from 'helpers/range';

const rvTimeRanges = pick(timeRanges, ['this-month', 'last-thirty-days', 'last-seven-days', 'custom-range']);

const LabRealValueDashboard = props => (
    <DashboardTemplate
        header={<HeaderContainer />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer timeRanges={rvTimeRanges} entityId={parseInt(props.match.params.entityId, 10)} pageRange={{ start_date: '2019-11-01' }} />}>

        <DetermineLayerContainer
            layerTwo={LabsRealValueContainer}
            layerThree={LabsRealValueContainer}
            {...props} />
    </DashboardTemplate>
);

export default compose(
    ProtectedRoute({ requiredCapabilities: [DASHBOARD_LABS_RV_VIEW, DASHBOARD_ACCESS] }),
    PageTitle({ pageTitle: 'Labs - RealValue Attribution' }),
    PageView({ page: 'Viewed RealValue Attribution', trackEntity: false }),
    PageTheme({ themeDefaults: { 'whitelabel.showGGBranding': showGGBrandingTheme } }),
    PageQuery({
        params: {
            ...getQueryParamDefForRange()
        },
        initialTruth: 'location',
    })
)(LabRealValueDashboard);



// WEBPACK FOOTER //
// ./src/components/pages/labs/LabRealValue.js